export const LAYOUT_HEIGHTS = {
    CONVERSATIONS_CONTAINER: 'calc(100vh - 135px)',
};

export const SKELETON_COUNT = 8;
